module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Ballers-S1.7b4acc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Ballers-S1.jpg
// module id = 5KwD
// module chunks = 0